import React, { Component } from "react";
import {
  TitleLabel,
  NomenclatureItem,
  UploadButton,
  UploadChipsContainer,
} from "./style";
import FileSelector, {
  getFileDescription,
  acceptTypes,
} from "../../../shared/controls/file-selector";
import SVGIcon, { icons } from "../../../shared/svg-icon";
import Chip from "../../../shared/controls/chip";

class RouteCatalogDetailsNomenclatures extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { nomenclature, editMode } = this.props;
    return (
      <React.Fragment>
        <TitleLabel>
          <label htmlFor="">Tipo de configuración vehicular</label>
        </TitleLabel>
        {nomenclature.items.map((item, key) => {
          return (
            <NomenclatureItem key={key}>{item.nomenclature}</NomenclatureItem>
          );
        })}
        <UploadChipsContainer>
          {nomenclature.files.map((item, key) => {
            return (
              <Chip
                key={key}
                id={key}
                active={true}
                className="white small full"
                name="files"
                description={getFileDescription(item, 10)}
                onClick={() => {}}
                prefix={{
                  element: (
                    <SVGIcon
                      name={icons.imageFile}
                      fill="#657795"
                      viewBox="0 -1 16 16"
                    />
                  ),
                }}
                suffix={{
                  element: (
                    <div
                      onClick={() =>
                        nomenclature.removeFiles("nomenclatures", item)
                      }
                    >
                      {" "}
                      <SVGIcon
                        name={icons.cross}
                        fill="#A7B6D6"
                        viewBox="0 3 16 16"
                      />
                    </div>
                  ),
                }}
              />
            );
          })}
        </UploadChipsContainer>
        {editMode && (
          <FileSelector
            name={"nomenclatures"}
            acceptTypes={[acceptTypes.xml]}
            onChange={(e) => nomenclature.handleInput(e)}
            allowMultiple={false}
          >
            <UploadButton
              settings={{
                type: "primary small",
                text: "Subir archivo",
                //   disabled: true,
                prefix: {
                  element: (
                    <SVGIcon
                      name={icons.uploadFile}
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                    />
                  ),
                },
              }}
            />
          </FileSelector>
        )}
      </React.Fragment>
    );
  }
}

export default RouteCatalogDetailsNomenclatures;

RouteCatalogDetailsNomenclatures.defaultProps = {};
